const InitialState = {
  logAccessCodes: {
    _id: "600d7c37aec9ecf3441c7bf5",
    name: "Siddhant Vinchurkar",
    email: "siddhantvinchurkar@gmail.com",
    access_code: "blahstuff",
    created_at: "2021-01-05T11:32:43.848Z",
    updated_at: "2021-01-05T11:32:43.848Z",
  },
  leads: {
    _id: "61276b6f368b940009396d98",
    ref: 0,
    name: "Kiran Gowda S",
    email: "kirangowdas2015@gmail.com",
    phone: "8892984948",
    message: "test",
    agreed_to_tc: true,
    source: "home-page",
    created_at: "2021-08-26T10:22:38.997Z",
    user_id: 0,
    __v: 0,
  },
  singleBlog: {
    _id: "603debdebf07327becb30c68",
    ref: 2,
    slug: "otp-based-property-registration",
    seo: {
      keywords: ["otp", "registration"],
      meta_title: "OTP Based Property Registration",
      meta_description: "",
    },
    title: "OTP Based Property Registration",
    subtitle: "",
    article:
      "**Know more about the registration process, documents required and the official government sites for registration.** ~69420 In a first of its kind initiative by a state government in India, the Government of Karnataka is about to launch a 2 Step One Time Password (OTP) based system. The system consists of 2 layers of security which, the officials believe will help in clamping down impersonating or forgery of land documents and this system will enhance the security of the existing Kaveri software. ~69420 The first layer of verification will require the seller to upload scanned property documents including **Khata certificate**, **Tax receipt** and the **RTC**, where applicable, ahead of registration of transfer of property ownership on the website [DEPARTMENT OF STAMPS AND REGISTRATION](https://www.karnataka.gov.in/karigr/Pages/Home.aspx). Upon the launch of the system, both the buyer and the seller will receive a one-time password (OTP) to authenticate the registration of the deed. ~69420 At present this system is live on a pilot basis in Shivamogga, Karnataka.  So far, it has received a positive response and is planned to be introduced in two more districts ahead of its statewide launch. The existing Kaveri software takes only the photo, thumb impressions and identity proof of the buyer and the seller of a particular property. The additional requirement of uploading of documents and OTP will further enhance the security features. The state government aims to target especially the urban areas where cases of impersonation and forgery are on a steady rise, with about 10,000 property registrations every day in the state, Bengaluru makes up about 70% of them, explaining the need of this system. ~69420 **STEPS REQUIRED FOR REGISTRATION OF TRANSFER OF PROPERTY OWNERSHIP:** ~69420 **1.UPLOADING DOCUMENTS ON [DEPARTMENT OF STAMPS AND REGISTRATION](https://www.karnataka.gov.in/karigr/Pages/Home.aspx).** ~69420 DOCUMENTS REQUIRED ~69420 1. Khata Certificate. ~69420 Visit [BBMP](http://bbmp.gov.in/khata-certificate) to obtain your Khata Certificate. ~69420 2. Tax Receipt.  ~69420 Visit [BBMPTAX](https://bbmptax.karnataka.gov.in/Forms/PrintForms.aspx?rptype=3) for printing your Receipt ~69420 3. RTC (Rights, Tenancy and Crops): Nature of the Land, Liabilities, Tenancy and Crops grown, etc. Visit [BHOOMI](http://landrecords.karnataka.gov.in/service2/RTC.aspx) to obtain your RTC. ~69420 **2.AUTHENTICATE THE REGISTRATION:** ~69420 OTPs will be sent to the owner’s and buyer’s mobile numbers respectively. Use the OTP received to authenticate the transfer of property. ~69420 SOURCES: Published by **Naveen Menezes** | Nov 05 2019, [READ HERE](https://economictimes.indiatimes.com/articleshow/71917146.cms?utm_source=contentofinterest&utm_medium=text&utm_campaign=cppst) ~69420 [#economictimes](https://economictimes.indiatimes.com/etreporter/author-Naveen%20Menezes-479247493.cms)",
    cover_image: {
      url: "https://bucket.beegru.in/blogs/otp_based.webp",
      caption: "OTP Based Property Registration",
    },
    thumbnail_image: {
      url: "https://bucket.beegru.in/blogs/otp_based_thumbnail.webp",
      caption: "OTP Based Property Registration",
    },
    featured_thumbnail_image: {
      url: "https://bucket.beegru.in/blogs/otp_based_featured_thumbnail.webp",
      caption: "OTP Based Property Registration",
    },
    category: "real-estate",
    featured: false,
    real_estate_update: true,
    author: "Ankit Chauhan",
    likes: 69,
    priority: 6,
    date_published: "2020-03-20T11:32:43.848Z",
    "created at": {
      $timestamp: {},
    },
    "updated at": {
      $timestamp: {},
    },
  },
  singleStream: {
    _id: "61b34d4a67428f3e9ed60927",
    ref: 1,
    slug: "residential-plot",
    title: "Residential Plots 30X40",
    subtitle: "Price Starting from 22L",
    description: "jzsdcbhjdasbjhdascjdascbjdcbjdbcnjdkcbnjdkscnbjkdscnbjd",
    category: "propertyshow",
    cover_image: "https://bucket.beegru.in/stream/bsr-akruthi.webp",
    thumbnail: "https://bucket.beegru.in/stream/bsr-akruthi.webp",
    youtube_embed: "https://www.youtube.com/embed/nz0CLjGJ5OM",
  },
  serviceLeads: {
    _id: "61275f0b29aefb3ba0d45b68",
    ref: 0,
    name: "Kiran Gowda S",
    email: "kirangowdas2015@gmail.com",
    phone: "8892984948",
    business_location: "1090I, 3rd Floor, 18th Cross Rd, HSR layout",
    business_type: "RERA Professional",
    message: "test",
    agreed_to_tc: true,
    source: "developers page",
    created_at: "2021-08-26T09:29:47.609Z",
    user_id: 0,
    __v: 0,
  },
  requirementLeads: {
    _id: "612e170eae113f33904ca9a7",
    ref: 0,
    name: "Kiran Gowda S",
    phone: "8892984948",
    email: "kirangowdas2015@gmail.com",
    location: "bangalore",
    comments: "fdsas",
    want: {
      buy: false,
      rent: false,
      lease: true,
      sell: true,
      joint_venture: true,
    },
    category: {
      residential: true,
      commercial: false,
      agricultural: false,
      industrial: true,
      warehousing: true,
      other: false,
    },
    type: {
      apartment: false,
      land: false,
      independent_house: false,
      villa: true,
      plots: true,
      plantations: true,
      farmhouse: false,
      co_living: false,
      office_space: false,
      factory: false,
      mining: true,
      other: false,
    },
    description: "ddas",
    created_at: "2021-08-31T11:48:30.960Z",
    user_id: 0,
    __v: 0,
  },
  singleProperty: {
    _id: "5fd0dc24fdbbc6370854fee2",
    ref: 1,
    slug: "vaishnavi-terraces",
    seo: {
      keywords: ["vaishnavi", "terraces"],
      meta_title: "Luxury Apartments for sale in JP Nagar: Vaishnavi Terraces",
      meta_description:
        "Vaishnavi Terraces by Vaishnavi Group. BDA Approved 3 BHK Luxury Apartments for sale in JP Nagar.",
    },
    title: "Vaishnavi Terraces",
    location: {
      title: "JP Nagar",
      pincode: 560076,
    },
    short_description: "3.5 BHK luxury Apartments for sale",
    builder: {
      name: "Vaishnavi Group",
      description:
        "Vaishnavi Group designs homes that resonate with the lifestyle needs of Urban Indians. Their projects are conceived using best in class construction technologies and design thinking. Their commitment to deliver a world-class customer experience reflects in their cutting-edge project delivery and customer relationship processes.",
      year_est: 1998,
      total_projects: 14,
      logo: {
        url: "https://bucket.beegru.in/vaishnavilogo.webp",
        caption: "Vaishnavi Group Logo",
      },
    },
    price: {
      min: {
        price: 2.45,
        multiplier: 10000000,
        unit: "Crore",
        calculated: 24500000,
      },
      max: {
        price: 2.45,
        multiplier: 10000000,
        unit: "Crore",
        calculated: 24500000,
      },
      discounted: {
        min: {
          price: 2.4,
          multiplier: 10000000,
          unit: "Crore",
          calculated: 2400000,
        },
        max: {
          price: 2.4,
          multiplier: 10000000,
          unit: "Crore",
          calculated: 2400000,
        },
      },
    },
    price_per_unit: {
      min: {
        ft: 1000,
        mt: 107456,
      },
      max: {
        ft: 1000,
        mt: 107456,
      },
    },
    tags: [
      {
        id: "sale",
        label: "Sale",
        icon: "property/sale",
      },
      {
        id: "residential",
        label: "Residential",
        icon: "property/residential",
      },
      {
        id: "apartment",
        label: "Apartment",
        icon: "property/apartment",
      },
      {
        id: "ready_to_move",
        label: "Ready to Move",
        icon: "property/readytomove",
      },
      {
        id: "nri",
        label: "NRI",
        icon: "property/nri",
      },
      {
        id: "featured",
        label: "Featured",
        icon: "property/featured",
      },
    ],
    area: {
      label: "2455 sqft.",
      enableLabel: false,
      super_built_up_area: {
        min: {
          ft: 2455,
          mt: 228,
        },
        max: {
          ft: 2455,
          mt: 228,
        },
      },
      built_up_area: {
        min: {
          ft: 2455,
          mt: 228,
        },
        max: {
          ft: 2455,
          mt: 228,
        },
      },
      carpet_area: {
        min: {
          ft: 1841,
          mt: 171,
        },
        max: {
          ft: 1841,
          mt: 171,
        },
      },
      karab_area: {
        min: {
          ft: 2455,
          mt: 228,
        },
        max: {
          ft: 2455,
          mt: 228,
        },
      },
    },
    mandate: true,
    config: {
      parameters: [
        {
          key: "bhk",
          values: ["3.5"],
        },
      ],
      label: "3.5 BHK",
    },
    cover_image: {
      url: "https://bucket.beegru.in/vaishnavi_terrace_cover_image.webp",
      caption: "Vaishnavi Terraces cover image",
    },
    thumbnail_image: {
      url: "https://bucket.beegru.in/vaishnavi_terrace_thumbnail.webp",
      caption: "Vaishnavi Terraces",
    },
    images: [
      {
        url: "https://bucket.beegru.in/vaishnavi_terrace_1.webp",
        caption:
          "Aerial View of Vaishnavi Terraces, 3.5 BHK luxury Apartments in JP Nagar",
        priority: 1,
      },
      {
        url: "https://bucket.beegru.in/vaishnavi_terrace_2.webp",
        caption:
          "Aerial View of Vaishnavi Terraces, 3.5 BHK luxury Apartments in JP Nagar",
        priority: 2,
      },
      {
        url: "https://bucket.beegru.in/vaishnavi_terrace_3.webp",
        caption:
          "Exterior View of Vaishnavi Terraces, 3.5 BHK luxury Apartments in JP Nagar",
        priority: 3,
      },
      {
        url: "https://bucket.beegru.in/vaishnavi_terrace_4.webp",
        caption:
          "Swimming Pool View of Vaishnavi Terraces, 3.5 BHK luxury Apartments in JP Nagar",
        priority: 4,
      },
      {
        url: "https://bucket.beegru.in/vaishnavi_terrace_5.webp",
        caption:
          "Club House View of Vaishnavi Terraces, 3.5 BHK luxury Apartments in JP Nagar",
        priority: 5,
      },
      {
        url: "https://bucket.beegru.in/vaishnavi_terrace_6.webp",
        caption:
          "Balcony garden View of Vaishnavi Terraces, 3.5 BHK luxury Apartments in JP Nagar",
        priority: 6,
      },
      {
        url: "https://www.youtube.com/embed/d6yNM5rdo2g",
        caption:
          "Walkthrough video of Vaishnavi Terraces, 3.5 BHK luxury Apartments in JP Nagar",
        priority: 7,
        video: true,
      },
    ],
    pdf: "https://bucket.beegru.in/pdf/vaishnavi_terrace.pdf",
    about_property: [
      "BDA Approved",
      "BBMP Limits",
      "G+26 floor structure",
      "A - Khata",
      "RCC Framed Structure",
      "Bank Loan Approved",
      "Landscaped garden",
      "Rainwater harvesting",
      "Vitrified tiles flooring",
      "20,000 Sqft Clubhouse",
      "Gated Community",
      "Intercom Facility",
    ],
    about_location: [
      "Located in one of Bangalore’s most sought after addresses – Dollars Colony, JP Nagar – Vaishnavi Terraces is right there amidst a host of places of everyday importance. From shopping malls, multiplexes, parks and restaurants to banks, hospitals, schools and commercial centers – everything lies within a short distance, giving you an easy commute and endless convenience.",
    ],
    amenities: [
      {
        id: "swimming_pool",
        label: "Swimming Pool",
        icon: "amenities/swimming",
      },
      {
        id: "jogging_track",
        label: "Jogging Track",
        icon: "amenities/joggingtrack",
      },
      {
        id: "club_house",
        label: "Club House",
        icon: "amenities/club",
      },
      {
        id: "meditation hall",
        label: "Meditation Hall",
        icon: "amenities/meditation",
      },
      {
        id: "jacuzzi",
        label: "jacuzzi",
        icon: "amenities/jacuzzi",
      },
      {
        id: "tennis",
        label: "Tennis Court",
        icon: "amenities/tennis",
      },
      {
        id: "power_backup",
        label: "Power Backup",
        icon: "amenities/powerbackup",
      },
      {
        id: "park",
        label: "Park",
        icon: "amenities/park",
      },
      {
        id: "rainwater_harvesting",
        label: "Rainwater Harvesting",
        icon: "amenities/rainwater",
      },
      {
        id: "security",
        label: "Security",
        icon: "amenities/security",
      },
      {
        id: "amphitheatre",
        label: "Amphitheatre",
        icon: "amenities/amphitheatre",
      },
      {
        id: "gym",
        label: "Gym",
        icon: "amenities/gym",
      },
      {
        id: "badminton",
        label: "Badminton Court",
        icon: "amenities/badminton",
      },
    ],
    beegru_score: {
      approval: {
        score: 10,
        description:
          "OC has been received and the JP Nagar Dollar’s colony area infrastructure has completely developed",
      },
      location: {
        score: 9.6,
        description:
          "JP Nagar dollars colony is a well-developed neighborhood. The location of this apartment is also connected to the bannerughatta road. The location is not very noisy but is very easily accessible from JP nagar side and Bannerughtta side.",
      },
      value: {
        score: 9.7,
        description:
          "The building is a complete Myvan complete RCC structure, one of the bestbuildings in the locality. There is great value for the property considering the price, the construction quality and the location.",
      },
      vaastu: {
        score: 8.5,
        description:
          "Flats are Vaastu compliant with Master bedrooms in south west and kitchens in southeast/Northwest",
      },
      neighbourhood: {
        score: 9,
        description:
          "Neighborhood is posh. Large house and big cars. The entire apartment complex is completely populated with an active association managing the premises.",
      },
      average: {
        score: 9.4,
        description:
          "A great place to live, a premium apartment in a posh locality. Highly Recommended!",
      },
    },
    vicinity: [
      {
        category: "schools",
        values: [
          {
            title: "Vibgyor High School",
            distance: 1.8,
          },
          {
            title: "Vet College",
            distance: 1.3,
          },
          {
            title: "Indian Institute of Management, Bengaluru",
            distance: 0.95,
          },
        ],
      },
      {
        category: "hospitals",
        values: [
          {
            title: "Fortis Hospital",
            distance: 2,
          },
          {
            title: "Apollo Hospital",
            distance: 1.7,
          },
          {
            title: "Jayadeva Hospital",
            distance: 2.3,
          },
        ],
      },
      {
        category: "malls",
        values: [
          {
            title: "Vega City Mall",
            distance: 0.85,
          },
          {
            title: "Gopalan Innovation Mall",
            distance: 2.9,
          },
          {
            title: "Bangalore Central Mall",
            distance: 1.9,
          },
        ],
      },
      {
        category: "others",
        values: [
          {
            title: "Upcoming Dollars colony Metro station",
            distance: 0.7,
          },
          {
            title: "Kalyani Magnum Tech Park",
            distance: 1.7,
          },
          {
            title: "JP Nagar Metro Station",
            distance: 3.2,
          },
        ],
      },
    ],
    types: ["featured", "nri"],
    priority: 6,
    gmaps_embed_url:
      "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15556.302663905928!2d77.598268!3d12.902856!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae15199fc6e967%3A0x8bb3e0c24a6df98b!2sVaishnavi%20Terrace%2C%20Dollars%20Colony%2C%20Phase%204%2C%20J.%20P.%20Nagar%2C%20Bengaluru%2C%20Karnataka%20560076!5e0!3m2!1sen!2sin!4v1608711353602!5m2!1sen!2sin",
    "created at": {
      $timestamp: {
        t: 1,
        i: 1630562188,
      },
    },
    "updated at": {
      $timestamp: {
        t: 2,
        i: 1630562188,
      },
    },
  },
};

export default InitialState;
